import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFreelancerComponent } from './simple-icons-freelancer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFreelancerComponent ],
    exports:      [ SimpleIconsFreelancerComponent ],
    bootstrap:    []
})
export class SimpleIconsFreelancerModule {}
